import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const Finish = ({ resetAppState = () => {}, /* projectTitle, */ onGoToCart = null }) => {
    const container = useRef(null);

    useEffect(() => {
        if (container?.current) {
            container.current.scrollIntoView({ behaviour: 'smooth' });
        }
    }, [container]);

    return (
        <div
            ref={container}
            className="overlay-warning-portal-wrapper builder-finish-overlay"
            role="dialog"
            aria-labelledby="finish-modal-title"
            aria-modal="true"
        >
            <span className="overlay-warning-backdrop" />
            <div className="overlay-warning warning-modal builder-finish-modal">
                <button
                    type="button"
                    aria-label="Close"
                    className="cancel-button"
                    onClick={() => {
                        resetAppState();
                    }}
                />
                <h2 id="finish-modal-title" className="warning-modal__title">
                    Project added to cart
                </h2>
                {/*
                    <div className="warning-modal__body">
                        {projectTitle && (
                            <p>
                                <strong>{projectTitle}</strong> has been added to your cart.
                            </p>
                        )}
                        <p>What would you like to do next?</p>
                    </div>
                */}
                <div className="warning-modal__actions builder-finish-actions">
                    <button
                        type="button"
                        className="warning-modal__button warning-modal__button--secondary"
                        onClick={() => {
                            resetAppState();
                            const builder = document.querySelector('.minifig-builder');
                            if (builder) builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }}
                    >
                        Start another build
                    </button>
                    <button
                        type="button"
                        className="warning-modal__button warning-modal__button--primary"
                        onClick={() => {
                            if (onGoToCart) onGoToCart();
                        }}
                    >
                        Go to cart
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Finish;

Finish.propTypes = {
    resetAppState: PropTypes.func.isRequired,
    projectTitle: PropTypes.string,
    onGoToCart: PropTypes.func,
};
